/** Flip to `true` to preview Home redesign (RedisignHomePage). Ship default false. */
export const USE_FAIR_HOME_V2 = true
